export default __webpack_public_path__ + "static/media/Favor of the Skeleton Concubines.7cece6b2.jpg";